import { observer } from 'mobx-react';
import * as React from 'react';
import Asynchronous from '../Asynchronous';
import Synchronous from '../Synchronous';
import { Value } from '..';
import { SelectionsField } from '../../../Types';

interface Props {
  field: SelectionsField;
  onChange: (value: Value) => void;
  dataIntercomTarget?: string;
}

const SyncOrAsync: React.FC<Props> = ({ field, onChange, dataIntercomTarget }) => {
  switch (field.options.kind) {
    case 'options-rel':
      return (
        <Asynchronous
          field={field}
          onChange={onChange}
          optionsRel={field.options.optionsRel}
          dataIntercomTarget={dataIntercomTarget}
        />
      );
    case 'options-list':
    case 'options-list-and-rel':
      return (
        <Synchronous
          field={field}
          onChange={onChange}
          options={field.options.options}
          dataIntercomTarget={dataIntercomTarget}
        />
      );
  }
};

export default observer(SyncOrAsync);
